import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';

const ItemPanel = ({ items = [], positionClass = '', zIndex = '' }) => {
	const { t } = useTranslation();

	return (
		<div
			className={`absolute bg-white select-none min-w-fit border border-border-default rounded-sm shadow-md z-10 ${positionClass}`}
		>
			<ul className='text-sm text-on-secondary'>
				{items.map((item) => {
					const Wrapper = item.url ? NavLink : 'div';

					return (
						<Wrapper
							key={item.label}
							to={item.url}
							onClick={item.onClick}
							className={`flex border-b border-tertiary px-3 py-2.5 gap-1 text-nowrap ${
								item.textClass || ''
							} ${zIndex}`}
						>
							{item.icon && <i className={item.icon} />}
							<p className='font-medium cursor-pointer hover:underline'>{t(item.label)}</p>
						</Wrapper>
					);
				})}
			</ul>
		</div>
	);
};

ItemPanel.propTypes = {
	items: PropTypes.arrayOf(
		PropTypes.shape({
			label: PropTypes.string.isRequired,
			icon: PropTypes.string,
			textClass: PropTypes.string,
			onClick: PropTypes.func,
			url: PropTypes.string,
		}),
	).isRequired,
	positionClass: PropTypes.string,
};

export default ItemPanel;
